import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { NavigationEnd, Router, Event, ActivatedRoute } from '@angular/router';
import { ApiService } from './shared/services/api.service';
import { LocaleService } from './shared/services/locale.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ViewportService } from './shared/services/viewport.service';
import { AuthService } from './shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectLanguageComponent } from './shared/select-language/select-language.component';
import { Observable } from 'rxjs/internal/Observable';
import { AmplitudeService } from './core/services/amplitude.service';
import { HeaderService } from './core/services/header.service';
import { LocaleType, LocaleDirection } from '@core/enums';
import { AdsService } from '@shared/services/ads.service';
import { User } from '@core/models';
import { CookieService } from '@shared/services/cookie.service';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
	constructor(
		private router: Router,
		private breakpointObserver: BreakpointObserver,
		private api: ApiService,
		private auth: AuthService,
		public locale: LocaleService,
		public viewport: ViewportService,
		private dialog: MatDialog,
		public amplitude: AmplitudeService,
		public header: HeaderService,
		private ads: AdsService,
		private route: ActivatedRoute,
		private cookie: CookieService
	) {}

	private subscriptions: Subscription = new Subscription();
	loading: boolean = true;
	embedded: boolean = false;
	intercomStarted: boolean = false;
	storedLang = localStorage.getItem('lang');
	increaseMaxWidth: boolean = false;
	increaseMaxWidthofAds: boolean = false;

	checkPrefferedLanguage(): Observable<string> {
		const dialogRef = this.dialog.open(SelectLanguageComponent, {
			width: '325px',
			height: '350px',
			data: {
				title: 'Welcome to Kurd Shopping!',
			},
			disableClose: true,
		});
		return dialogRef.afterClosed();
	}

	getProductData(lang) {
		let body = {
			lang: lang,
		};

		this.api.getProductValues(body).subscribe((res) => {
			if (res.status === '1') {
				this.ads.callsCount = res['response']['callsCount'];
				this.ads.basicProductIQD = res['response']['basicProductIQD	'];
				this.ads.vipProductIQD = res['response']['vipProductIQD'];
			}
		});
	}

	ngOnInit(): void {
		window.addEventListener('beforeunload', () => {
			console.log('Storing the cache data');
			this.api.storeCacheData();
		});

		this.locale.initialize();

		this.subscriptions.add(
			this.router.events.subscribe((event: Event) => {
				if (event instanceof NavigationEnd) {
					this.embedded = event['urlAfterRedirects'].includes('embedded=true');

					this.increaseMaxWidth = event['urlAfterRedirects'].includes('payment/tier');
					this.increaseMaxWidthofAds = event['urlAfterRedirects'].includes('c/');

					this.viewport.showFooter =
						event['urlAfterRedirects'].includes('placead') ||
						event['urlAfterRedirects'].includes('edit') ||
						event['urlAfterRedirects'].includes('tier') ||
						event['urlAfterRedirects'].includes('payment/confirm') ||
						event['urlAfterRedirects'].includes('user/wa-alerts')
							? false
							: true;

					let lang = localStorage.getItem('lang');

					if (!lang) {
						const translationsFormData: FormData = new FormData();
						// the popup to be shown in english so setting 'en' as default for first time
						translationsFormData.set('lang', 'en');
						this.api.getTranslations(translationsFormData).subscribe((res) => {
							this.locale.lang = 'en';
							this.locale.translations = res['response'];
							this.loading = false;
							this.checkPrefferedLanguage().subscribe((selectedLang) => {
								lang = selectedLang;
								// save the user's language preference in local storage
								localStorage.setItem('lang', lang);
								this.cookie.set('lang', lang);
								//Modifying the URL to display selected language in URL
								let currentUrl = this.router.url;
								if (currentUrl === '/') currentUrl = ''; //For home page
								const modifiedUrl = `/${lang}${currentUrl}`;

								this.setLocaleDirection(lang);

								// load the translations for the selected language if not in en as everything is loaded
								if (lang !== 'en') {
									this.loadTranslations(lang, null);

									// this.router.navigate([], {
									// 	relativeTo: this.route,
									// 	queryParamsHandling: 'merge',
									// });
								}
								this.router.navigateByUrl(modifiedUrl);
							});
						});
						// show the modal popup and get the user's language preference
					} else {
						// load the translations for the stored language preference
						this.loadTranslations(lang, null);
						this.setLocaleDirection(lang);
					}

					if (!this.intercomStarted && !this.embedded) {
						this.auth.bootIntercom();
						//this.intercomStarted = true;
					}

					// token-in-URL authentication is handled in the AuthGuard

					// token validation
					const validateTokenFormData: FormData = new FormData();
					const user: User = this.auth.user();

					if (
						!event['urlAfterRedirects'].includes('/login') &&
						!event['urlAfterRedirects'].includes('/login') &&
						!event['urlAfterRedirects'].includes('/register') &&
						user
					) {
						validateTokenFormData.append('userID', user['userID']);

						this.api.validateToken(validateTokenFormData).subscribe((res) => {
							if (res['status'] !== '1') {
								this.auth.logout();
								window.location.reload();
							}
						});
					}
				}
			})
		);

		this.breakpointObserver.observe(['(max-width: 480px)', '(max-width: 840px)']).subscribe((res) => {
			if (res['breakpoints']['(max-width: 480px)'] === true) {
				this.viewport.type = 'mobile';
			} else if (res['breakpoints']['(max-width: 840px)'] === true) {
				this.viewport.type = 'tablet';
			} else {
				this.viewport.type = 'desktop';
			}
		});
	}

	loadTranslations(lang: string, callback: () => void): void {
		if (this.locale.lang !== lang) {
			this.loading = true;
			const translationsFormData: FormData = new FormData();
			translationsFormData.set('lang', lang);

			this.api.getTranslations(translationsFormData).subscribe((res) => {
				this.locale.lang = lang;
				this.locale.translations = res['response'];

				this.getProductData(lang);
				this.loading = false;

				if (callback) {
					callback();
				}
			});
		}
	}

	private setLocaleDirection(lang: string): void {
		switch (lang) {
			case LocaleType.ARABIC:
			case LocaleType.KURDISTAN:
				this.locale.setLocaleDirection(LocaleDirection.RTL);

				break;
			case LocaleType.ENGLISH:
				this.locale.setLocaleDirection(LocaleDirection.LTR);

				break;
			default:
				this.locale.setLocaleDirection(LocaleDirection.LTR);
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
